export const queryKeys = {
  getRolePermissionLookups: "getRolePermissionLookups",
  getRolePermissions: "getRolePermissions",
};
